import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { ProfileSelectorComponent } from '../profile-selector/profile-selector.component';

@Component({
  selector: 'app-tool-bar',
  imports: [TranslateModule, LanguageSelectorComponent, ProfileSelectorComponent],
  templateUrl: './tool-bar.component.html',
  styleUrl: './tool-bar.component.scss',
})
export class ToolBarComponent {
  isMenuOpen = input.required<boolean>();
  toggleMenu = output<boolean>();

  onClickToggleMenu() {
    this.toggleMenu.emit(!this.isMenuOpen());
  }
}
